function isEqual(valueA, valueB) {
  return valueA?.unit === valueB?.unit && valueA?.value === valueB?.value;
}

export default isEqual;
